// ---------- Auth Actions ----------
export const SET_ME_DATA = "SET_ME_DATA";

export const setMeData = (data) => ({
  type: SET_ME_DATA,
  payload: data,
});
